<div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="login-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.5'}}">
            <img src="assets/images/logos/asso.png">
        </div>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            Bienvenidos a JEP.
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            Experiencia en servicios de Asesoramiento.
        </div>

    </div>

    <div id="login-form-wrapper" fusePerfectScrollbar
         [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="login-form">

            <div class="logo" fxHide.gt-xs>
                <img src="assets/images/logos/asso.png">
            </div>

            <div class="title">INGRESAR A SU CUENTA</div>

            <form name="loginForm" [formGroup]="loginForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>Usuario</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>
                        El usuario es requeridos
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Contraseña</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        La contraseña es requerida
                    </mat-error>
                </mat-form-field>
                
                <mat-radio-group fxLayout="column" fxLayoutAlign="start start" formControlName="type">
                    <mat-radio-button class="mb-12" value="E">Empresa</mat-radio-button>
                    <mat-radio-button class="mb-12" value="P">Persona</mat-radio-button>
                </mat-radio-group>

                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                     fxLayoutAlign="space-between center">
                    <mat-checkbox class="remember-me" aria-label="Remember Me">
                       Recordarme
                    </mat-checkbox>

                    <a class="forgot-password" [routerLink]="'/pages/auth/forgot-password-2'">
                        Perdió su contraseña ?
                    </a>
                </div>

                <button mat-raised-button color="accent" class="submit-button" aria-label="LOGIN"
                        [disabled]="loginForm.invalid">
                    INGRESAR
                </button>
                <div class="title center center"></div>
                <button mat-raised-button color="accent" class="submit-button" aria-label="LOGIN" [routerLink]="'/apps/calendar/new'">
                    Agendar cita
                </button>

            </form>
<!--
            <div class="separator">
                <span class="text">OR</span>
            </div>

            <div fxLayout="column" fxLayoutAlign="start center">

                <button mat-raised-button class="google">
                    Log in with Google
                </button>

                <button mat-raised-button class="facebook">
                    Log in with Facebook
                </button>

            </div>

            <div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">Don't have an account?</span>
                <a class="link" [routerLink]="'/pages/auth/register-2'">Create an account</a>
            </div>
        -->
        <div style="text-align: center; padding-bottom: 10px;">
            <span>Powered by <a href="http://www.impeltechnology.com/portal" target="_blank">IMPEL</a></span>
        </div>
        </div>
    </div>
</div>
